import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-orange-light, #FF937A)",
			fillRule: "evenodd",
			d: "m50.45 7.25 20.73 35.94a3.54 3.54 0 0 1-3.06 5.3h-41.5a3.54 3.54 0 0 1-3.05-5.3L44.3 7.25a3.55 3.55 0 0 1 6.14 0m-3.08 32.08a1.31 1.31 0 1 0 0-2.63 1.31 1.31 0 0 0 0 2.63",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-orange-light, #FF937A)",
			d: "M158.94 38.84c-7.5-1.42-14.63 2.98-15.93 9.83-.44 2.4-.12 4.87.9 7.08l-3.24 5.3 6.13-1.25a14.6 14.6 0 0 0 7.44 3.82c7.49 1.42 14.63-2.99 15.92-9.83 1.3-6.85-3.72-13.54-11.22-14.95"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-deep, #7698D7)",
			d: "M45.99 78.93v6.12l2.76-1.13v-3.13a9 9 0 0 1-2.76-1.86"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-deep, #7698D7)",
			d: "M45.99 92.26V194.5h2.76V90.54c-.87.54-1.87 1.19-2.76 1.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-deep, #7698D7)",
			d: "m103.45 71.25-1.5 2.16.03-1.83z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-deep, #7698D7)",
			d: "m141.64 77.41.45-.28c.1-.05 4.02-1.41 4.08-1.44-2.57-1.28-4.81-.71-4.53 1.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-deep, #7698D7)",
			d: "m149.84 83-2.59.9c1.75.72 3.49.62 3.96-.83z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-deep, #7698D7)",
			d: "M95.04 191.69q-.33-3.32-1.44-6.47a22.5 22.5 0 0 1-12.34 0c-5.35 1.55-11.46 6.3-14.65 9.28 10.74 0 17.84-.1 26.01-.11a2.42 2.42 0 0 0 2.42-2.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-deep, #7698D7)",
			d: "m154.97 175.55-3.52-1.9c-1.4 4.6-3.06 5.96-7.4 8.8 2.18 3.25 1.67 4.85 1.42 5.8-2.28 2.15-3.43 2.15-5.02 6.27h7.96a5.6 5.6 0 0 0 5.16-3.13c1.2-2.59 2.19-7.83 3.3-10.91a3.95 3.95 0 0 0-1.9-4.94"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-deep, #7698D7)",
			d: "M157.4 55.64a.65.65 0 1 1-1.24-.3.65.65 0 0 1 1.24.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-deep, #7698D7)",
			d: "M46 78.5v-30h2.77v30.17c-1.69-.3-2.5-.33-2.76-.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-deep, #7698D7)",
			d: "M121.94 57.91a2.59 2.59 0 0 0-.6-5.08 2.6 2.6 0 0 0-2.4-4.45 2.6 2.6 0 0 0-2.23-3.7 2.6 2.6 0 0 0-1.61.45 2.6 2.6 0 0 0-4.84-1.59 2.7 2.7 0 0 0-4.38-1.6c-.48.4-.81.96-.93 1.58a2.6 2.6 0 0 0-4.86 1.55 2.6 2.6 0 0 0-3.88 3.22 2.61 2.61 0 0 0-2.45 4.42 2.6 2.6 0 0 0-.67 5.08 2.6 2.6 0 0 0 .63 5.09 2.6 2.6 0 0 0 2.44 4.42 2.6 2.6 0 0 0 2.53 3.68c-1.15-.92-1.57-2.98.32-7.35 3.37-7.77 6.45-2.34 6.4.81.06.57.39.69 1.24-.01 1.77-1.48 3.32 1.62-.06 3.4-.64.34-1.08 1.1-.53 5.27q.05.45.15.89a2.64 2.64 0 0 0 3.8-1.91 2.6 2.6 0 0 0 4.88-1.51 2.6 2.6 0 0 0 3.9-3.18 2.6 2.6 0 0 0 2.47-4.4 2.6 2.6 0 0 0 .68-5.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint0_linear_4001_10468)",
			d: "M157.4 55.64a.66.66 0 0 1-.68.62.65.65 0 0 1-.62-.61.7.7 0 0 1 .37-.62.65.65 0 0 1 .93.61Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint1_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M45.99 78.5v-30"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint2_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M45.99 85.05v-6.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint3_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M45.99 194.53V92.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint4_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M48.77 90.61v103.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint5_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M48.77 80.8v3.14"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint6_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M48.77 48.5v30.17"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint7_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M149.14 85.45a47.4 47.4 0 0 1-19.92 60.32"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint8_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M65.4 79.82a47.4 47.4 0 0 1 25.86-20.33m51.65 15.65a47.4 47.4 0 0 0-19.19-14.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint9_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M87.48 148.29a47.4 47.4 0 0 1-27.05-57.47"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint10_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M113.76 151.3c-2.62.54-5.3.76-7.96.65q-1.95 0-3.88-.15"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint11_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M150.83 83.75c-3.71 3.7-8.61 9.07-13.67 15.18a7.8 7.8 0 0 1-10.59 1.34c-4.44-3.23-7.45-5.56-12.32-9.13"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint12_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m101.92 73.44 1.53-2.19"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint13_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M142.06 75.67a71 71 0 0 0-11.12 12.16s-9.44-7.9-15.9-11.83c-6.67-4.06-8.24 2.65-8.98-2.93-.55-4.18-.11-4.94.53-5.27 3.38-1.79 1.83-4.89.06-3.4-1.06.88-1.18.49-1.22-.33-.18-3.19-3.16-7.96-6.4-.47-4.58 10.57 4.42 7.65 4.42 7.65"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint14_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.98 71.56c.11 1.62-.15 4.23-1.76 3.85-4.12-.97-5.88-.32-8.22 1.5-4.66 3.62-14.12 8.98-14.12 8.98-5.62-3.39-9.68-4.84-14.92-7.1-2.77 3.07-4.38 7.01-4.55 11.14 7.46 3.2 10.32 5.03 16.16 7.88a8.7 8.7 0 0 0 8.34-.36A207 207 0 0 1 93.8 91.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint15_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M146.18 75.7c-2.26-1.13-4.27-.83-4.53.9-.24 1.5.78 3.25 1.74 4.4a9.3 9.3 0 0 0 5.35 3.3 2.05 2.05 0 0 0 2.47-1.23"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint16_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M92.62 83.28c.41 6.24 2 12.35 4.7 18 5.78 1.53 10.46 1.17 16.3-.61-.46-4.38.12-8.8 1.69-12.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint17_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M147.25 83.9a57 57 0 0 1 8.25-2.47q3.78-.66 7.61-.38c3.75.22 4.34-.63.48-1.95-1.42-.49-8.68-1.51-10.29-1.74a95 95 0 0 0-8.88-.81q-.3 0-.57.03"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint18_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M141.64 77.41c.05-.03 8.78-3.28 12.25-4.87 4.03-1.85 2.94-.42 1.9.81-.75.9-4.51 3.4-2.49 4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint19_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M149.82 82.99c2.3-.55 6.8-.08 8.81.04 1.63.1 4 .62 5.8.8.42.03.88-.57-1.54-1.56-.91-.36-2.51-1.03-3.27-1.26"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint20_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M149.73 83.03q2.83 0 5.6.6c1.49.35 3.99 1.3 5.59 1.73.4.1.95-.42-1.27-1.8l-.85-.52"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint21_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M58.58 88.25a53 53 0 0 0-9.23-.55q-3.83.3-7.5 1.44c-3.6 1.11-4.38.4-.93-1.8a129 129 0 0 1 18.03-6.99c.88-.24 1.8-.21 2.67.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint22_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M50.58 83.22c1.81-1.08-2.48-2.59-3.42-3.28-1.29-.95-2.7-2.07 1.66-1.25q5.5 1.12 11.08 1.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint23_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M45.21 88.29c-.8.49-2.38 1.64-2.83 1.99-2.1 1.54-1.53 2.02-1.14 1.89 1.57-.54 3.99-1.69 5.45-2.14 2.36-.74 6.9-2.3 9.05-2.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint24_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M46.55 90.06q-.48.51-.71.72c-1.82 1.85-1.18 2.25-.82 2.04 1.45-.8 3.65-2.3 5.03-2.98q2.54-1.2 5.24-1.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint25_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M95.04 191.69q-.33-3.32-1.44-6.47a22.5 22.5 0 0 1-12.34 0c-5.35 1.55-11.46 6.3-14.65 9.28 10.74 0 17.84-.1 26.01-.11a2.4 2.4 0 0 0 2.32-1.69q.16-.5.1-1.01"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint26_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M100.07 155.64c.12 5.28-4.09 15.74-6.47 29.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint27_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m81.26 185.22 6.15-31.74"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint28_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m108.16 132.28-7.43 23.25c-4.9.86-9.94-.04-14.23-2.54l10.83-51.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint29_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m154.99 175.56-3.52-1.89c-1.4 4.6-3.09 5.96-7.41 8.8 2.17 3.25 1.66 4.85 1.41 5.8-2.28 2.15-3.43 2.12-5.02 6.24h7.96a5.6 5.6 0 0 0 5.16-3.12c1.2-2.6 2.19-7.83 3.3-10.91a3.94 3.94 0 0 0-1.88-4.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint30_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m144.08 182.46-22.78-24.55"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint31_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M131.2 150.14q4.81 3.97 8.64 8.9a450 450 0 0 0 11.63 14.63"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint32_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m103.45 114.36 8.7 33.17c.66 2.52 2 4.8 3.9 6.6l4.33 4.12a20.8 20.8 0 0 0 11.16-8.64l-3.9-6.47-2.48-25.21c-.91-9.4-6.52-15.87-11.54-17.26"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint33_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M110.2 74.64c-3.19 4-5.72 8.49-7.5 13.29-2.52-4.14-4.98-12.94-4.98-12.94"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint34_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M26.55 194.53h150.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint35_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M158.94 38.84c-7.5-1.42-14.63 2.98-15.93 9.83-.44 2.4-.12 4.87.9 7.08l-3.24 5.3 6.13-1.25a14.6 14.6 0 0 0 7.44 3.82c7.49 1.42 14.63-2.99 15.92-9.83 1.3-6.85-3.72-13.54-11.22-14.95"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint36_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M156.74 52.77c.02-.85.35-1.47 1.4-2.88 2.27-3.02.9-5.1-1.04-5.2a2.35 2.35 0 0 0-2.44 2.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint37_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M148.54 144.4h4.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint38_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M159.86 144.37h4.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint39_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M156.24 136.68v4.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint40_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M156.26 148v4.09"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint41_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m150.79 138.95 2.89 2.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint42_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m158.82 146.95 2.9 2.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint43_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m161.7 138.93-2.9 2.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint44_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m153.7 146.95-2.9 2.89"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint45_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M26.63 48.5a3.54 3.54 0 0 1-3.06-5.31L44.3 7.25a3.55 3.55 0 0 1 6.15 0l20.73 35.94a3.54 3.54 0 0 1-3.06 5.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint46_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M76.87 27.72a1.9 1.9 0 1 1-3.78.34 1.9 1.9 0 0 1 3.78-.34"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint47_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M61.5 165.38V173"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint48_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M65.32 169.2h-7.65"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint49_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M106.21 73.96a2.6 2.6 0 0 0 3.8-1.87 2.6 2.6 0 0 0 4.88-1.52 2.6 2.6 0 0 0 3.9-3.17 2.6 2.6 0 0 0 3.24-2.98 2.6 2.6 0 0 0-.77-1.43 2.59 2.59 0 0 0 2-4.15 2.6 2.6 0 0 0-1.32-.93 2.6 2.6 0 0 0 1.89-2.53 2.6 2.6 0 0 0-2.5-2.56 2.6 2.6 0 0 0-2.4-4.44 2.6 2.6 0 0 0-3.83-3.25 2.6 2.6 0 0 0-4.84-1.6c-.43-2.9-4.86-2.97-5.32-.01a2.6 2.6 0 0 0-4.85 1.55 2.61 2.61 0 0 0-3.88 3.21 2.6 2.6 0 0 0-2.46 4.43 2.6 2.6 0 0 0-.66 5.08 2.6 2.6 0 0 0 .63 5.09 2.6 2.6 0 0 0 2.43 4.42 2.59 2.59 0 0 0 2.6 3.68"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint50_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m127.52 154.28-4.94-5.88"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint51_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m95.3 155.62 2.03-7.33"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint52_linear_4001_10468)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M110.2 107.25c2.7 3.27 5.71 4.65 8.94 4.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint53_linear_4001_10468)",
			d: "M46.06 38.02a1.31 1.31 0 1 0 2.63 0 1.31 1.31 0 0 0-2.63 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#warning_svg__paint54_linear_4001_10468)",
			strokeLinecap: "round",
			d: "M47.36 19.3v12.72"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint0_linear_4001_10468",
				x1: 156.569,
				x2: 157.022,
				y1: 55.84,
				y2: 55.438,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint1_linear_4001_10468",
				x1: 46.347,
				x2: 46.967,
				y1: 68.737,
				y2: 68.718,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint2_linear_4001_10468",
				x1: 46.347,
				x2: 46.954,
				y1: 83.068,
				y2: 82.98,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint3_linear_4001_10468",
				x1: 46.347,
				x2: 46.967,
				y1: 161.278,
				y2: 161.273,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint4_linear_4001_10468",
				x1: 49.126,
				x2: 49.746,
				y1: 160.725,
				y2: 160.72,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint5_linear_4001_10468",
				x1: 49.126,
				x2: 49.701,
				y1: 82.918,
				y2: 82.756,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint6_linear_4001_10468",
				x1: 49.126,
				x2: 49.746,
				y1: 68.851,
				y2: 68.833,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint7_linear_4001_10468",
				x1: 137.864,
				x2: 151.081,
				y1: 126.15,
				y2: 121.514,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint8_linear_4001_10468",
				x1: 93.377,
				x2: 97.267,
				y1: 73.207,
				y2: 60.102,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint9_linear_4001_10468",
				x1: 68.902,
				x2: 83.92,
				y1: 129.594,
				y2: 122.883,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint10_linear_4001_10468",
				x1: 106.193,
				x2: 106.225,
				y1: 151.757,
				y2: 151.276,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint11_linear_4001_10468",
				x1: 127.45,
				x2: 132.824,
				y1: 95.902,
				y2: 86.261,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint12_linear_4001_10468",
				x1: 102.472,
				x2: 103.159,
				y1: 72.73,
				y2: 72.304,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint13_linear_4001_10468",
				x1: 113.731,
				x2: 123.125,
				y1: 78.652,
				y2: 65.621,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint14_linear_4001_10468",
				x1: 74.143,
				x2: 83.111,
				y1: 89.878,
				y2: 77.156,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint15_linear_4001_10468",
				x1: 145.074,
				x2: 148.34,
				y1: 81.341,
				y2: 78.383,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint16_linear_4001_10468",
				x1: 100.809,
				x2: 107.45,
				y1: 96.07,
				y2: 89.051,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint17_linear_4001_10468",
				x1: 151.921,
				x2: 153.607,
				y1: 81.509,
				y2: 76.978,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint18_linear_4001_10468",
				x1: 147.095,
				x2: 148.565,
				y1: 75.539,
				y2: 72.131,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint19_linear_4001_10468",
				x1: 155.217,
				x2: 155.62,
				y1: 82.909,
				y2: 81.02,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint20_linear_4001_10468",
				x1: 153.899,
				x2: 154.257,
				y1: 84.608,
				y2: 83.047,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint21_linear_4001_10468",
				x1: 46.975,
				x2: 49.525,
				y1: 86.58,
				y2: 81.129,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint22_linear_4001_10468",
				x1: 50.935,
				x2: 52.076,
				y1: 81.654,
				y2: 78.718,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint23_linear_4001_10468",
				x1: 46.233,
				x2: 47.11,
				y1: 90.803,
				y2: 88.099,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint24_linear_4001_10468",
				x1: 48.464,
				x2: 49.899,
				y1: 91.258,
				y2: 88.532,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint25_linear_4001_10468",
				x1: 76.877,
				x2: 78.993,
				y1: 191.484,
				y2: 185.754,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint26_linear_4001_10468",
				x1: 95.937,
				x2: 99.803,
				y1: 175.613,
				y2: 174.867,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint27_linear_4001_10468",
				x1: 83.478,
				x2: 87.178,
				y1: 174.899,
				y2: 174.266,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint28_linear_4001_10468",
				x1: 94.315,
				x2: 106.27,
				y1: 138.101,
				y2: 133.908,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint29_linear_4001_10468",
				x1: 146.472,
				x2: 153.366,
				y1: 187.737,
				y2: 182.861,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint30_linear_4001_10468",
				x1: 129.52,
				x2: 137.966,
				y1: 174.477,
				y2: 167.556,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint31_linear_4001_10468",
				x1: 138.518,
				x2: 146.473,
				y1: 166.016,
				y2: 159.964,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint32_linear_4001_10468",
				x1: 113.592,
				x2: 128.275,
				y1: 139.521,
				y2: 133.195,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint33_linear_4001_10468",
				x1: 102.227,
				x2: 106.808,
				y1: 83.605,
				y2: 79.804,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint34_linear_4001_10468",
				x1: 80.824,
				x2: 80.829,
				y1: 195.2,
				y2: 194.498,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint35_linear_4001_10468",
				x1: 151.391,
				x2: 160.265,
				y1: 55.65,
				y2: 46.453,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint36_linear_4001_10468",
				x1: 156.329,
				x2: 158.628,
				y1: 50.141,
				y2: 48.963,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint37_linear_4001_10468",
				x1: 150.012,
				x2: 150.193,
				y1: 145.068,
				y2: 144.416,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint38_linear_4001_10468",
				x1: 161.335,
				x2: 161.516,
				y1: 145.049,
				y2: 144.397,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint39_linear_4001_10468",
				x1: 156.602,
				x2: 157.194,
				y1: 139.435,
				y2: 139.307,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint40_linear_4001_10468",
				x1: 156.621,
				x2: 157.213,
				y1: 150.758,
				y2: 150.63,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint41_linear_4001_10468",
				x1: 151.832,
				x2: 152.833,
				y1: 140.887,
				y2: 139.997,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint42_linear_4001_10468",
				x1: 159.865,
				x2: 160.866,
				y1: 148.883,
				y2: 147.993,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint43_linear_4001_10468",
				x1: 159.847,
				x2: 160.853,
				y1: 140.881,
				y2: 139.991,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint44_linear_4001_10468",
				x1: 151.851,
				x2: 152.857,
				y1: 148.896,
				y2: 148.006,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint45_linear_4001_10468",
				x1: 40.623,
				x2: 55.715,
				y1: 34.504,
				y2: 19.455,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint46_linear_4001_10468",
				x1: 74.457,
				x2: 75.778,
				y1: 28.553,
				y2: 27.386,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint47_linear_4001_10468",
				x1: 61.857,
				x2: 62.469,
				y1: 170.529,
				y2: 170.458,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint48_linear_4001_10468",
				x1: 60.432,
				x2: 60.533,
				y1: 169.869,
				y2: 169.182,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint49_linear_4001_10468",
				x1: 102.99,
				x2: 114.441,
				y1: 63.554,
				y2: 53.539,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint50_linear_4001_10468",
				x1: 124.364,
				x2: 126.338,
				y1: 152.367,
				y2: 150.904,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint51_linear_4001_10468",
				x1: 96.035,
				x2: 97.219,
				y1: 153.235,
				y2: 152.947,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint52_linear_4001_10468",
				x1: 113.429,
				x2: 114.838,
				y1: 110.36,
				y2: 107.947,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint53_linear_4001_10468",
				x1: 47.009,
				x2: 47.924,
				y1: 38.477,
				y2: 37.67,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "warning_svg__paint54_linear_4001_10468",
				x1: 47.716,
				x2: 48.333,
				y1: 27.883,
				y2: 27.84,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			})
		] })
	]
});
export default SvgWarning;
